import React from "react";
import { bool, func, shape, string } from "prop-types";

import { ACCOUNT_TITLE } from "../constants";
import { ItemText, MenuListItem } from "../MultiLevelMenu";

const AccountTrigger = props => (
  <MenuListItem isFullSize isSignIn>
    <ItemText
      isBig
      isSignIn={!(props.is_agent_or_small_landlord || props.is_manager)}
      isWithArrow
      onClick={props.onClick}
    >
      {props.is_agent_or_small_landlord || props.is_manager ? (
        ACCOUNT_TITLE
      ) : (
        <>
          <span className="u-visuallyHidden">Signed in account menu</span>
          <span>{props.current_user?.email}</span>
        </>
      )}
    </ItemText>
  </MenuListItem>
);

AccountTrigger.propTypes = {
  is_agent_or_small_landlord: bool,
  is_manager: bool,
  current_user: shape({
    email: string
  }),
  onClick: func
};

AccountTrigger.defaultProps = {
  is_agent_or_small_landlord: false,
  is_manager: false,
  current_user: null,
  onClick: () => ({})
};

export default AccountTrigger;
